/**
 * Tiny bus so the phone avatar menu can open the same Add-to-Home-Screen sheet.
 *
 * PT-2: the sheet does not open on its own. ?rl_sheet=1 still forces it for smoke.
 * Standalone hides the menu item. The ae mark does not open the sheet.
 */

const openListeners = new Set()
const DISMISS_KEY = 'ae-rl-sheet-dismissed'

export function isLocalDevHost () {
  if (typeof window === 'undefined') return false
  const h = window.location.hostname || ''
  return h === 'localhost' || h === '127.0.0.1' || h === '[::1]'
}

/** Explicit URL force — works even ≥768px for local smoke. */
export function wantsForcedRocketLauncherSheet () {
  if (typeof window === 'undefined') return false
  try {
    const q = new URLSearchParams(window.location.search || '')
    const v = q.get('rl_sheet')
    return v === '1' || v === 'true'
  } catch (e) {
    return false
  }
}

/** Mount the sheet host outside Phone Smarty when forcing local smoke. */
export function shouldMountRocketLauncherSheet (phoneSmarty) {
  return !!phoneSmarty || wantsForcedRocketLauncherSheet() || isLocalDevHost()
}

/**
 * Normal visits stay quiet. Only ?rl_sheet=1 opens the sheet without a click.
 */
export function shouldAutoOpenRocketLauncherSheet () {
  return wantsForcedRocketLauncherSheet()
}

export function noteRocketLauncherSheetDismissed () {
  try {
    sessionStorage.setItem(DISMISS_KEY, '1')
  } catch (e) { /* ignore */ }
}

export function openRocketLauncherSheet () {
  openListeners.forEach((fn) => {
    try { fn() } catch (e) { /* ignore */ }
  })
}

export function subscribeRocketLauncherSheet (callback) {
  if (typeof callback !== 'function') return () => {}
  openListeners.add(callback)
  return () => { openListeners.delete(callback) }
}
